import { render, staticRenderFns } from "./StartSideNeedsActivation.vue?vue&type=template&id=32b000a3"
import script from "./StartSideNeedsActivation.vue?vue&type=script&lang=js"
export * from "./StartSideNeedsActivation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports